module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"is_website_partner":"Ist Website-Partner","website_url":"Website-URL","website_logo":"Website-Logo","rules_required":"Pflichtfeld","rules_max_length":"Maximal %{maxLength} Zeichen"},"en":{"is_website_partner":"Is Webiste-Partner","website_url":"Website URL","website_logo":"Website logo","rules_required":"Required","rules_max_length":"No more than %{maxLength} characters"}}')
  delete Component.options._Ctor
}
